import * as THREE from 'three';

const createRobotArm = (
    scene: THREE.Scene,
    materials: any,
    componentsRef: React.MutableRefObject<Array<{
        mesh: THREE.Mesh;
        solidMaterial: THREE.Material;
        wireframeMaterial: THREE.Material;
    }>>,
    xPos: number,
    yPos: number,
    zPos: number
) => {
    const robotGroup = new THREE.Group();
    robotGroup.position.set(xPos, yPos, zPos);

    // 底部
    const baseGeometry = new THREE.CylinderGeometry(1, 1.2, 1, 32);
    const baseMesh = new THREE.Mesh(baseGeometry, materials.robotRed.clone());
    baseMesh.position.y = 0.5;
    robotGroup.add(baseMesh);
    componentsRef.current.push({
        mesh: baseMesh,
        solidMaterial: materials.robotRed.clone(),
        wireframeMaterial: materials.wireframeCyan.clone()
    });

    // 下臂
    const lowerArmGeometry = new THREE.BoxGeometry(0.8, 4, 0.8);
    const lowerArmMesh = new THREE.Mesh(lowerArmGeometry, materials.robotRed.clone());
    lowerArmMesh.position.y = 3;
    robotGroup.add(lowerArmMesh);
    componentsRef.current.push({
        mesh: lowerArmMesh,
        solidMaterial: materials.robotRed.clone(),
        wireframeMaterial: materials.wireframeCyan.clone()
    });

    // 上臂
    const upperArmGeometry = new THREE.BoxGeometry(0.7, 3, 0.7);
    const upperArmMesh = new THREE.Mesh(upperArmGeometry, materials.robotRed.clone());
    upperArmMesh.position.y = 6;
    robotGroup.add(upperArmMesh);
    componentsRef.current.push({
        mesh: upperArmMesh,
        solidMaterial: materials.robotRed.clone(),
        wireframeMaterial: materials.wireframeCyan.clone()
    });

    // 夹具/末端执行器 (简化)
    const gripperGeometry = new THREE.BoxGeometry(0.5, 0.5, 1.5);
    const gripperMesh = new THREE.Mesh(gripperGeometry, materials.solidBlack.clone());
    gripperMesh.position.set(0, 7.5, 0);
    robotGroup.add(gripperMesh);
    componentsRef.current.push({
        mesh: gripperMesh,
        solidMaterial: materials.solidBlack.clone(),
        wireframeMaterial: materials.wireframeCyan.clone()
    });

    scene.add(robotGroup);
};

export const createRobotArms = (
    scene: THREE.Scene,
    materials: any,
    componentsRef: React.MutableRefObject<Array<{
        mesh: THREE.Mesh;
        solidMaterial: THREE.Material;
        wireframeMaterial: THREE.Material;
    }>>
) => {
    // 添加两个机器人手臂
    createRobotArm(scene, materials, componentsRef, -8, 0, 5);
    createRobotArm(scene, materials, componentsRef, 8, 0, 5);
}; 